import { Component, inject } from '@angular/core';
import {
  InputLabelComponent,
  NumberInputComponent,
  SelectInputComponent,
} from '@navstation-portal/shared/ui/components';
import { injectDispatch } from '@ngrx/signals/events';
import { FormsModule } from '@angular/forms';
import { SelectOption } from '@navstation-portal/shared/data-model/common';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreStockFormEvents,
  OffshoreStockFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-fuel-rob',
  templateUrl: './fuel-rob.component.html',
  imports: [
    FormsModule,
    NumberInputComponent,
    SelectInputComponent,
    InputLabelComponent,
  ],
})
export class FuelRobComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'stock';
  sectionId = 'fuelRob';
  events = injectDispatch(offshoreStockFormEvents);
  offshoreStockStore = inject(OffshoreStockFormStore);

  filterAvailableFuelTypeOptions = (index: number): SelectOption[] => {
    const availableFuelTypeOptions =
      this.reportStore.availableFuelGradeOptions();

    const selectedKeys = new Set(
      this.offshoreStockStore.fuelRob().fuelRobRows.flatMap((row, rowIndex) => {
        if (rowIndex === index) return [];
        const key = row.fuelType.value?.code;
        return key ? [key] : [];
      }),
    );

    return availableFuelTypeOptions.filter((option) => {
      const key = option.code;
      return key ? !selectedKeys.has(key) : true;
    });
  };
}
